import React from "react";
import { SettingsUpdate } from "./about-us";

const TermsAndConditions = () => (
	<SettingsUpdate type={"terms"} title="Terms and Conditions" />
);

export default TermsAndConditions;
